<template>
  <div class="mx-auto text-center">
    <div v-if="!imgUrl">
      <div class="w-full">
        <croppa
          :width="360"
          :height="270"
          :placeholder="$t('Subir Fichero')"
          :accept="'image/*'"
          :prevent-white-space="true"
          :quality="2"
          v-model="myCroppa"
          canvas-color="transparent"
        ></croppa>
      </div>
      <div class="text-center mb-2 mx-auto">
        <span class="flex w-64 rounded-md shadow-sm mx-auto">

          <button
            @click="generateImage"
            type="button"
            class="inline-flex mt-2 justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          >
            {{$t('Ajustar y Recortar')}}
          </button>
        </span>
        <!-- <button >Recortar</button> -->
      </div>
    </div>
    <div
      v-else
      class="w-full flex justify-center"
    >
      <div>
        {{$t('PREVISUALIZACIÓN')}}
        <img
          class="output max-w-sm"
          :src="imgUrl"
        >
        <div class="text-center mt-2 mx-auto">
          <span class="flex w-64 rounded-md shadow-sm mx-auto">
            <button
              @click="enviar"
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-gray-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-gray-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
             {{$t('Subir Fichero')}}
            </button>
          </span>
          <div v-if="uploadingImage">
            {{$t('subiendo')}} {{uploadProgress}}
          </div>
        </div>
      </div>
    </div>
    <br>

  </div>
</template>
<script>
export default {
  props: ["carpeta", "tipo", "imageId", "nombre", "accept", "max", "ventana"],
  data() {
    return {
      myCroppa: null,
      imgUrl: ""
    };
  },
  computed: {
    uploadingImage(){
      return this.$store.state.uploadingImage
    },
    uploadProgress(){
      return this.$store.state.uploadProgress
    }
  },
  methods: {
    enviar() {
      const carpeta = this.carpeta;
      const tipo = this.tipo;
      const nombre = this.nombre;
      const imageId = this.imageId;

      let blobImagen = "";

      const type = "image/jpg";
      const compressionRate = "0.7";
      this.myCroppa.generateBlob(
        blob => {
          blobImagen = blob;
          // console.log("haciendo blob");
          var re = /(?:\.([^.]+))?$/;
          // this.imageUrl = fr.result;
          // this.fichero = files[0]; // this is an image file that can be sent to server...
          const fichero = blobImagen;
          const extension = "jpg";
          const fileName = nombre + "__" + tipo + "." + extension.toLowerCase();
          const formato = "jpg";
          const datos = {
            carpeta,
            tipo,
            nombre,
            fichero,
            fileName,
            extension,
            imageId,
            formato
          };

          this.$store.dispatch("uploadImage", datos).then(doc => {
            // console.log('ha llegado cerrarVentna',doc , datos)
            this.$emit("accion", doc);
            this.$emit("cerrar", this.ventana);
          });
        },
        type,
        compressionRate
      );
    },
    accion() {
      // console.log("accions");
      this.$emit("accion", this.imgUrl);
    },
    generateImage: function() {
      let url = this.myCroppa.generateDataUrl("image/jpg", 0.7);

      if (!url) {
        const mensaje = this.$t('falta imagen')
        alert(mensaje);
        return;
      }
      this.imgUrl = url;
    }
  }
};
</script>
<style>
.croppa-container {
  background-color: white;
  border: 3px solid black;
  position: relative
}

.croppa-container svg {
  position: absolute;
}
</style>